/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_My_TasksInputs */

const en_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Tasks`)
};

const fr_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes taches`)
};

const de_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Aufgaben`)
};

const it_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie attivita`)
};

const ru_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои задачи`)
};

const es_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis tareas`)
};

const zh_cn2_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的任务`)
};

const ja_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイタスク`)
};

const hi_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरे कार्य`)
};

const pt_pt2_explorer_nav_my_tasks = /** @type {(inputs: Explorer_Nav_My_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As minhas tarefas`)
};

/**
* | output |
* | --- |
* | "My Tasks" |
*
* @param {Explorer_Nav_My_TasksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_my_tasks = /** @type {((inputs?: Explorer_Nav_My_TasksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_My_TasksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_my_tasks(inputs)
	if (locale === "de") return de_explorer_nav_my_tasks(inputs)
	if (locale === "it") return it_explorer_nav_my_tasks(inputs)
	if (locale === "ru") return ru_explorer_nav_my_tasks(inputs)
	if (locale === "es") return es_explorer_nav_my_tasks(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_my_tasks(inputs)
	if (locale === "ja") return ja_explorer_nav_my_tasks(inputs)
	if (locale === "hi") return hi_explorer_nav_my_tasks(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_my_tasks(inputs)
	return en_explorer_nav_my_tasks(inputs)
});